import { createSelector } from 'reselect'
import getSampleHistoryCustomerSelect from 'modules/customer/redux/selectors/get-sample-history'

const getSampleHistoryQuestionsCustomerSelect = createSelector(
  getSampleHistoryCustomerSelect,
  sampleHistory => sampleHistory?.data?.questions || []
)

export default getSampleHistoryQuestionsCustomerSelect
